import Auth from '../lib/Auth'

export const loginSuccess = user => ({
  type: 'LOGIN_SUCCESS',
  payload: user
})

export const logout = () => async (dispatch) => {
  await Auth.logout()
  dispatch({ type: 'LOGOUT_SUCCESS' })
}

export const loadingDone = { type: 'DONE_LOADING' }



// WEBPACK FOOTER //
// client/redux/authActions.js